import { render } from "./AssociationOnboardingKYC.vue?vue&type=template&id=48357cfe&scoped=true&ts=true"
import script from "./AssociationOnboardingKYC.vue?vue&type=script&lang=ts"
export * from "./AssociationOnboardingKYC.vue?vue&type=script&lang=ts"

import "./AssociationOnboardingKYC.vue?vue&type=style&index=0&id=48357cfe&scoped=true&lang=css"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48357cfe"]])

export default __exports__